// Kassim Consulting · final content per build spec + feedback (Feb 2026)

export const BRAND = {
  name: "Kassim Consulting",
  tagline: "Relocation with Dignity. Compliance with Precision.",
  founder: "Ismael Kassim",
  office: "(202) 883-8599",
  cell: "(202) 413-1651",
  email: "ismael@kassimconsulting.com",
  address: "2121 1st St SW, Washington, DC 20024",
  city: "Washington, DC",
  copyrightYear: 2026,
};

// Certifications (Relocation practice)
export const CERTIFICATIONS = [
  { code: "CBE", label: "DC Certified Business Enterprise" },
  { code: "LBE", label: "Local Business Enterprise" },
  { code: "DBE", label: "Disadvantaged Business Enterprise" },
  { code: "SBE", label: "Small Business Enterprise" },
  { code: "DZE", label: "Development Zone Enterprise" },
];

// Single practice (Division II removed per client feedback · Feb 2026)
export const PRACTICES = [
  {
    slug: "relocation",
    eyebrow: "Our Practice",
    title: "Relocation Services",
    short:
      "URA, HUD 1378, RAD, and Section 8 compliant resident relocation for affordable and mixed-use housing.",
    long:
      "We plan and execute URA, HUD 1378, RAD, and Section 8 compliant relocations for affordable and mixed-use housing. We move people with dignity and keep projects on schedule.",
    cta: "Explore Relocation",
    image:
      "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  },
];

export const STATS = [
  { value: "1,500+", label: "Households Relocated" },
  { value: "240",    label: "Units in Largest Project" },
  { value: "8",      label: "Multifamily Relocation Projects" },
  { value: "DC · MD · VA", label: "Service Region" },
];

// Relocation practice · expanded service descriptions (no one-liners per client feedback)
export const RELOCATION_SERVICES = [
  {
    title: "Relocation Planning & Execution",
    description:
      "We deliver end-to-end temporary and permanent move management, from initial resident outreach and individualized planning through coordinated move logistics and post-move stabilization. Every relocation is sequenced with the construction schedule so residents move once, on time, and into housing that actually fits their needs.",
  },
  {
    title: "Compliance & Documentation",
    description:
      "Full URA, HUD 1378, RAD, and Section 8 compliance: Replacement Housing Payment (RHP) calculations, statutory notices, benefits coordination, claims processing, and audit-ready file documentation. We build the paper trail funders, monitors, and auditors expect to see, and we keep it current through closeout.",
  },
  {
    title: "Resident Engagement & Community Outreach",
    description:
      "Culturally responsive engagement with strong community outreach. Multilingual communication, ADA and mobility accommodations, individualized assessments, and one-on-one resident counseling. We meet residents where they are, in person, in their language, and on their schedule.",
  },
  {
    title: "HQS Inspections & Property Transition",
    description:
      "Housing Quality Standards (HQS) inspections, pre-move and post-move unit reviews, and oversight of property transitions between project phases. We document condition, flag risks early, and protect both residents and ownership from disputes downstream.",
  },
  {
    title: "Digital File Automation",
    description:
      "Centralized compliance tracking built on Python and Google Apps Script. Resident files, notices, RHP calculations, and benefits status are tracked in real time, with audit trails and status dashboards leadership can actually use to make decisions.",
  },
  {
    title: "Interagency Coordination",
    description:
      "We sit at the center of the project team: property managers, caseworkers, housing authorities, development partners, and city agencies. We translate between regulatory requirements and field execution so the project moves forward without surprises.",
  },
];

// Regulations We Master · tightened redundancy per client feedback
export const RELOCATION_REGULATIONS = [
  "Uniform Relocation Assistance Act (URA, 1970, as amended)",
  "HUD Handbook 1378 (Tenant Assistance, Relocation & Real Property Acquisition)",
  "Rental Assistance Demonstration (RAD) Program",
  "Section 8 (Housing Choice Voucher & Project-Based)",
  "Section 104(d), Housing and Community Development Act",
];

// Projects (Page 4) · scope removed per client feedback
export const PROJECTS = [
  { name: "Jubilee Housing",        owner: "Jubilee Housing",                  units: 188, location: "Washington, DC" },
  { name: "Belmont Crossing",       owner: "Gilbane Development",              units: 240, location: "Washington, DC" },
  { name: "Henson Ridge I",         owner: "Urban Atlantic",                   units: 176, location: "Washington, DC" },
  { name: "Heritage at Old Town",   owner: "Jair Lynch",                       units: 185, location: "Alexandria, VA" },
  { name: "Springvale Terrace",     owner: "Seabury Resources",                units: 118, location: "Silver Spring, MD" },
  { name: "Villages of East River", owner: "IBF Development",                  units: 202, location: "Washington, DC" },
  { name: "Worthington Woods",      owner: "Montgomery Housing Partnership",   units: 233, location: "Washington, DC" },
  { name: "Ridgecrest Apartments",  owner: "NHP Foundation",                   units: 221, location: "Washington, DC" },
];

// Hero / media · Washington, DC skyline at golden hour
export const HERO_VIDEO =
  "https://videos.pexels.com/video-files/6133588/6133588-hd_1920_1080_30fps.mp4";

export const HERO_VIDEO_FALLBACK =
  "https://videos.pexels.com/video-files/5486747/5486747-hd_1920_1080_30fps.mp4";

export const HERO_POSTER =
  "https://images.pexels.com/videos/6133588/pexels-photo-6133588.jpeg?auto=compress&cs=tinysrgb&w=2400";

export const FOUNDER_IMAGE =
  "https://customer-assets.emergentagent.com/job_operations-hub-54/artifacts/uulcpyni_rs%3Dw_730%2Ccg_true.webp";

export const BRAND_LOGO_WHITE = "/logo-white.png";
export const BRAND_LOGO_NAVY  = "/logo-navy.png";

export const CBE_BADGE =
  "https://customer-assets.emergentagent.com/job_operations-hub-54/artifacts/7aqxmw3w_Screenshot%202026-06-12%20at%204.07.32%E2%80%AFPM.png";

// Imagery used across pages (more pictures per client feedback)
// Source: Pexels (verified housing-specific) + Unsplash (verified)
export const IMAGES = {
  // Home · services preview
  homeServicesA: "https://images.pexels.com/photos/3016321/pexels-photo-3016321.jpeg?auto=compress&cs=tinysrgb&w=1600",
  homeServicesB: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",

  // Relocation · multifamily & residential (all Pexels-verified)
  relocationConstructionA: "https://images.pexels.com/photos/3016321/pexels-photo-3016321.jpeg?auto=compress&cs=tinysrgb&w=1600",   // Apartment with balconies
  relocationConstructionB: "https://images.pexels.com/photos/18093637/pexels-photo-18093637.jpeg?auto=compress&cs=tinysrgb&w=1600", // Row houses
  relocationCommunity:     "https://images.pexels.com/photos/32646146/pexels-photo-32646146.jpeg?auto=compress&cs=tinysrgb&w=1600", // Urban apartment at dusk
  relocationFamily:        "https://images.pexels.com/photos/5505129/pexels-photo-5505129.jpeg?auto=compress&cs=tinysrgb&w=1600",   // Colorful row houses
  relocationApartment:     "https://images.pexels.com/photos/34281368/pexels-photo-34281368.jpeg?auto=compress&cs=tinysrgb&w=1600", // Apartment complex
  relocationMoving:        "https://images.pexels.com/photos/18923560/pexels-photo-18923560.jpeg?auto=compress&cs=tinysrgb&w=1600", // Modern apartment balconies

  // Operations · dashboards, analytics, collaboration
  opsDashboard:      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  opsCollaboration:  "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  opsAnalytics:      "https://images.unsplash.com/photo-1543286386-713bdd548da4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  opsBoardroom:      "https://images.unsplash.com/photo-1573164713988-8665fc963095?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  opsCode:           "https://images.unsplash.com/photo-1518186285589-2f7649de83e0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",

  // Projects · multifamily banner
  projectsBanner:    "https://images.pexels.com/photos/34281368/pexels-photo-34281368.jpeg?auto=compress&cs=tinysrgb&w=2400",
  projectsHousing:   "https://images.pexels.com/photos/293983/pexels-photo-293983.jpeg?auto=compress&cs=tinysrgb&w=1600",

  // About · DC skyline (uses the verified Pexels DC sunrise poster)
  aboutOffice:       "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  aboutDC:           "https://images.pexels.com/videos/6133588/pexels-photo-6133588.jpeg?auto=compress&cs=tinysrgb&w=2400",
  aboutMeeting:      "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",

  // Contact · DC skyline (same verified Pexels source)
  contactDC:         "https://images.pexels.com/videos/6133588/pexels-photo-6133588.jpeg?auto=compress&cs=tinysrgb&w=1600",
};

// Staff
export const STAFF = [
  {
    name: "Adriana Michienzi",
    role: "Consultant Strategist · Maryland",
    bio: "Consultant strategist for our Maryland engagements. Adriana shapes engagement strategy, advises on compliance and resident outreach, and ensures every Maryland project hits its targets.",
    image: "https://customer-assets.emergentagent.com/job_operations-hub-54/artifacts/gxjkdw30_Adriana%20-%20Picture%20%281%29.jpeg",
  },
  {
    name: "Jacob Celestine",
    role: "President",
    bio: "President of Kassim Consulting. Jacob leads firm-wide operations, business development, and client relationships, overseeing team performance and project delivery while guiding the firm’s growth.",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_operations-hub-54/artifacts/8e2f0fa74f87a28d_B1AFAF6C-879B-4C8F-86C5-ACC23BB4473B.jpeg",
  },
  {
    name: "Mohamed Nur",
    role: "Project Manager · Virginia",
    bio: "Project manager for our Virginia engagements. Mohamed leads project execution, URA / HUD-compliant resident relocation, and community outreach across VA projects.",
    image: "https://customer-assets.emergentagent.com/job_operations-hub-54/artifacts/bfb0t57g_IMG_2041%20%282%29.jpeg",
  },
];

// Navigation (Operations & Analytics removed per client feedback · Feb 2026)
export const NAV = [
  { label: "Home",       to: "/" },
  { label: "Relocation", to: "/relocation" },
  { label: "Projects",   to: "/projects" },
  {
    label: "About",
    to: "/about",
    children: [
      { label: "Our Firm",      to: "/about" },
      { label: "Meet the Team", to: "/team" },
    ],
  },
  { label: "Contact",    to: "/contact" },
];

// Primary CTA · renamed "Start a Project" to "Contact Us" per client feedback
export const PRIMARY_CTA = { label: "Contact Us", to: "/contact" };

// New "Free Consultation" CTA · top-right of every page · routes to dedicated booking page
export const CONSULTATION_CTA = {
  label: "Free Consultation",
  to: "/consultation",
};
